import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Bugsnag from '../helpers/bugsnag.js';

function FilterAccordionItem({
  id,
  selectedItems,
  title,
  itemList,
  onChange,
  onClear,
  collapsed
}) {
  const [searchTerm, setSearchTerm] = useState('');

  const getFiltered = (localItemList, localSearchTerm) => {
    try {
      if (!localSearchTerm) return localItemList;
      return localItemList
        .filter((item) => (item ? item.toLowerCase().includes(searchTerm.toLowerCase()) : null));
    } catch (e) {
      Bugsnag.notify(e);
      return [];
    }
  };

  return (
    <div className="accordion-item">
      <div id={`heading-${id}`} className="accordion-header">
        { selectedItems.length > 0
            && (
            <Link
              className="btn btn-link" onClick={() => onClear(title)}
            >
              Clear
            </Link>
            )}
        <button
          type="button"
          className={collapsed ? 'accordion-button collapsed' : 'accordion-button'}
          data-bs-toggle="collapse"
          data-bs-target={`#collapse-${id}`}
          aria-expanded="false"
          aria-controls={`collapse-${id}`}
        >
          {title}
        </button>
      </div>
      <div
        id={`collapse-${id}`}
        className={collapsed ? 'accordion-collapse collapse' : 'accordion-collapse collapse show'}
        aria-labelledby={`heading-${id}`}
      >
        <div className="accordion-body">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="form-control search-input search-input-focus"
            placeholder="Search"
          />
          { itemList ? getFiltered(itemList, searchTerm)
            .map((item, key) => (
              <div className="topping day-filter-item" key={key}>
                <label className="cursor-pointer mt-2">
                  <input
                    type="checkbox"
                    checked={selectedItems.indexOf(item) > -1}
                    readOnly
                    id={item}
                    onClick={() => onChange(selectedItems.includes(item)
                      ? selectedItems.filter((i) => i !== item)
                      : [...selectedItems, item])}
                  />
                  <span className="me-2" />
                  <a>{item}</a>
                </label>
              </div>
            )) : null}
        </div>
      </div>
    </div>
  );
}

FilterAccordionItem.defaultProps = {
  collapsed: true
};

FilterAccordionItem.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  selectedItems: PropTypes.arrayOf(PropTypes.string).isRequired,
  itemList: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  collapsed: PropTypes.bool
};

export default FilterAccordionItem;
